import { graphql } from "gatsby"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { PageLayout, PageTitle, WorkHistory } from "../components"
import { SEO, Utils } from "../utils"

export default ({ data }) => {
  const history = data.allMarkdownRemark.edges || []
  const images = data.allFile.edges || []
  const imageMap = Utils.getImageMap(images, /\/[work].*\/|$/)

  return (
    <PageLayout pageName="resume">
      <SEO title="CV" />
      <PageTitle title="CV" />

      {/* Bannière téléchargement */}
      <Container className="mb-5">
        <div className="cv-download-banner d-flex justify-content-between align-items-center">
          <small className="text-muted">Dernière mise à jour : Novembre 2025</small>
          <a
            href="cv_regis_atemengue.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download
            className="cv-download-btn"
          >
            ⬇ Télécharger mon CV
          </a>
        </div>
      </Container>

      {/* Timeline */}
      <Container className="mb-5">
        <h5 className="cv-section-title mb-4">Expérience Professionnelle</h5>
        <div className="cv-timeline">
          {history.map(({ node }) => (
            <WorkHistory
              key={node.id}
              frontmatter={node.frontmatter}
              image={imageMap[node.fields.slug]}
              html={node.html}
            />
          ))}
        </div>
      </Container>
    </PageLayout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/work/" } }
      sort: { fields: [frontmatter___endDate], order: DESC }
    ) {
      edges {
        node {
          id
          html
          frontmatter {
            company
            location
            position
            tags
            startDate(formatString: "MMM YYYY")
            endDate(formatString: "MMM YYYY")
          }
          fields {
            slug
          }
        }
      }
    }
    allFile(
      filter: {
        extension: { eq: "png" }
        relativePath: { regex: "/company/" }
        relativeDirectory: { regex: "/content/work/" }
      }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 80) {
              ...GatsbyImageSharpFluid
            }
          }
          relativePath
        }
      }
    }
  }
`
